import * as ls from 'local-storage';

export const getAuth = () => {
    if (window.SPONSOR_AUTH) {
        return window.SPONSOR_AUTH;
    } else {
        return ls.get('auth');
    }
};